var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 58",
    style: {
      enableBackground: "new 0 0 86 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,952.4c-4.9,0-9,4.1-9,9v40c0,4.9,4.1,9,9,9h68c4.9,0,9-4.1,9-9v-40c0-4.9-4.1-9-9-9H9z M9.8,958.4h66.5L45,985.6 c-1.2,1.1-2.7,1.1-3.9,0L9.8,958.4z M6,963l21.2,18.4L6,1001.3L6,963z M80,963.1v38.2l-21.2-19.8L80,963.1L80,963.1z M54.3,985.4 l20.2,18.9H11.5l20.2-18.9l5.4,4.7c3.3,2.9,8.4,2.9,11.8,0L54.3,985.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7d4fcc06450a933ae0eb02536bd3b345.svg";
export { ForwardRef as ReactComponent };